module.exports = __webpack_public_path__ + "assets/img/29_249.dfaa6adc.jpg";